import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { useDispatch, useSelector } from "react-redux";
import {
  isArrayNonEmpty,
  isValidElement,
  isValidString,
  safeStringValue,
} from "../../util/ApiHelper";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import { startCase } from "lodash";
import { getNewLine } from "../../util/helper";
import RFQStatusTags from "../requestQuotation/RFQStatus";
import { Button, Card, Image, List } from "antd";
import { LeftOutlined } from "@ant-design/icons";

const ChaQuotationsView = () => {
  const history = useHistory();
  const { isMobile } = useGetBreakpoints();
  const dispatch = useDispatch();
  const { id } = useParams();
  const moment = require("moment");
  const userData = useSelector(({ auth }) => auth?.userData);
  const [chaQuotationData, setChaQuotationData] = useState(null);
  const [fileName, setFileName] = useState(null);
  const getFreightRateQuotationById = useCallback(
    async (id) => {
      if (isValidString(id)) {
        dispatch(fetchStart());
        try {
          const chaQuotationById = await axiosInstance.get(
            `${BASE_API_CONFIG.baseURL}/enquiries/${id}`
          );
          setChaQuotationData(chaQuotationById?.data.data);
        } catch (error) {
          console.log("error getting Freight Rate", error);
        } finally {
          dispatch(fetchSuccess());
        }
      }
    },
    [dispatch]
  );

  const cargoReadinessDate = moment(
    chaQuotationData?.cargoReadinessDate
  ).format("DD-MMM-YYYY");

  useEffect(() => {
    getFreightRateQuotationById(id);
  }, [getFreightRateQuotationById, id]);

  useEffect(() => {
    if (isArrayNonEmpty(chaQuotationData?.productImages)) {
      const fileNames = chaQuotationData?.productImages?.map((image) => {
        return image;
      });
      setFileName(fileNames);
    }
  }, [chaQuotationData]);

  const data = [
    {
      label: "Product Name",
      value: chaQuotationData?.productName,
    },
    {
      label: "Product Catergory",
      value: chaQuotationData?.categories.name,
    },
    {
      label: "HS code / Item Description",
      value: `${chaQuotationData?.hscode?.code} - ${chaQuotationData?.hscode?.description}`,
    },
    {
      label: "Loading Country",
      value: chaQuotationData?.sourceCountry,
    },
    {
      label: "Loading Port",
      value: chaQuotationData?.sourcePort,
    },
    {
      label: "Destination Country",
      value: chaQuotationData?.destinationCountry,
    },
    {
      label: "Destination Port",
      value: chaQuotationData?.destinationPort,
    },
    {
      label: "Shipping Mode",
      value: startCase(chaQuotationData?.shipmentMode),
    },
    {
      label: "Shipping Type",
      value: startCase(chaQuotationData?.shipmentType),
    },
    // ...(isValidElement(chaQuotationData?.totalCubicMeter) ||
    // isValidElement(chaQuotationData?.noOfContainers)
    //   ? [
    //       {
    //         label: "Quantity",
    //         value:
    //           safeStringValue(chaQuotationData?.shipmentMode) === "air"
    //             ? `${chaQuotationData?.totalCubicMeter} Cubic Meter`
    //             : chaQuotationData?.noOfContainers +
    //               " " +
    //               (chaQuotationData?.noOfContainers > 1
    //                 ? "Containers"
    //                 : "Container") +
    //               (chaQuotationData?.containerType
    //                 ? `(${chaQuotationData?.containerType})`
    //                 : ""),
    //       },
    //     ]
    //   : []),
    {
      label: "Cargo Readiness Date",
      value: cargoReadinessDate,
    },
    {
      label: "Requirements",
      value: getNewLine(chaQuotationData?.description),
    },
    ...(isValidElement(chaQuotationData?.excludedCompanyNames)
      ? [
          {
            label: "Exclude users from sending CHA",
            value: (
              <RFQStatusTags status={chaQuotationData?.excludedCompanyNames} />
            ),
          },
        ]
      : []),
    {
      label: "Status",
      value: <RFQStatusTags status={chaQuotationData?.status} />,
    },
    ...(isValidElement(chaQuotationData?.currency)
      ? [
          {
            label: "Currency",
            value: chaQuotationData?.currency,
          },
        ]
      : []),
    ...(isValidElement(chaQuotationData?.rateindication)
      ? [
          {
            label: "Rate Indication",
            value: chaQuotationData?.rateindication,
          },
        ]
      : []),
  ];

  const navigateProfileEdit = () => {
    history.push(`/rfq-cha/details/${id}`);
  };

  return (
    isValidElement(chaQuotationData) && (
      <Card className="myexim-detail-card">
        <div className="myexim-table-title">
          <LeftOutlined
            // className={"back-icon"}
            style={{ fontSize: "20px", color: "#434E5B" }}
            size="large"
            onClick={() => {
              history.goBack();
            }}
          />{" "}
          CHA Details
        </div>

        <div className="logo-with-list gx-mt-4">
          {isValidString(chaQuotationData?.primaryImage) && (
            <div className={"logo-container"}>
              <div className={"logo-image"}>
                <img
                  alt="..."
                  src={chaQuotationData?.primaryImage}
                  width={120}
                  height={120}
                />
              </div>
            </div>
          )}
          <div style={{ flex: 1 }}>
            <List
              itemLayout="horizontal"
              dataSource={data}
              renderItem={(item) =>
                item?.value && (
                  <List.Item className="myexim-details-list">
                    <List.Item.Meta
                      title={<div>{item.label}</div>}
                      description={item.value}
                    />
                  </List.Item>
                )
              }
            />
            {fileName?.length > 0 && (
              <div className="attachments">
                <div className="sub-header"> Attachments</div>
                <div className="gx-pt-4">
                  {fileName?.map((fileName, index) => (
                    <div key={index} className="gx-pb-3">
                      <Image
                        className="gx-rounded-lg"
                        width={isMobile ? "100%" : 150}
                        height={isMobile ? "100%" : 150}
                        src={fileName?.src}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        <div
          style={{
            justifyContent: isMobile ? "center" : "end",
            display: "flex",
            flex: 1,
            flexWrap: "wrap",
            alignItems: "center",
          }}
          // className="gx-pt-4"
        >
          <Button
            type="secondary"
            size="large"
            onClick={() => {
              history.goBack();
            }}
            className="submit-btn"
            style={{
              marginRight: isMobile ? 0 : "",
            }}
          >
            Back
          </Button>
          {chaQuotationData?.totalQuotations > 0 ? (
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              onClick={() => {
                history.push({
                  pathname: `/rfq/quotations-list/${id}`,
                  state: {
                    party: chaQuotationData?.targetedBusinessType?.[0],
                  },
                });
              }}
              className="submit-btn"
            >
              View Quotations
            </Button>
          ) : (
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              onClick={navigateProfileEdit}
              className="submit-btn"
              disabled={chaQuotationData?.status === chaQuotationData.PUBLISHED}
            >
              Edit
            </Button>
          )}
        </div>
      </Card>
    )
  );
};

export default ChaQuotationsView;
